import { render, staticRenderFns } from "./GivRequestCard.vue?vue&type=template&id=af4a87a6&"
import script from "./GivRequestCard.vue?vue&type=script&lang=js&"
export * from "./GivRequestCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports